






















import VueOptions from '@utils/VueOptions'

settings =
  name: 'LoginForm'

  vue:
    props: ['data']

    data: ->
      rules:
        password: [
          { required: true, message: 'Please input the password' }
        ]

export default VueOptions.vue settings
